import { pdpTypeFormat } from "@/utils/helper"
import DesignServices from "@/components/ProductDetail/v3/DesignServices"

const AddOnService = props => {
  const {
    isDiscontinued,
    designServiceDataFromProp,
    productType,
    staticTexts,
    currencySign,
    businessUnitName,
    ProductPriceSpiderIncluded_s: productPriceSpiderIncludeds,
    ProductRequiredAccessoriesGroupsList,
    designServiceData,
    persona,
    replaceAddToCart,
    disableRatings,
    replaceAddToCartCtaLink,
    replaceAddToCartCtaLabel,
    linkNewTab,
    disableEcommerce,
    currencyCode,
    discontinuedProductb,
    superSku,
    locale,
    width,
  } = props

  return (
    !isDiscontinued &&
    designServiceDataFromProp.map((list, i) => {
      const { productType: productTypes = [] } = list
      return (
        productTypes.includes(productType) && (
          <div
            key={i}
            className="row no-gutters product-detail-page__design-services"
          >
            <DesignServices
              staticTexts={staticTexts}
              currencySign={currencySign}
              pdpType={pdpTypeFormat({
                businessUnitName,
                ProductPriceSpiderIncluded_s: productPriceSpiderIncludeds,
                discontinuedProductb,
                ProductRequiredAccessoriesGroupsList,
                superSku,
              })}
              sku={list.sku}
              designServiceAPIData={designServiceData.filter(
                item => item.masterVariant.sku === list.sku
              )}
              persona={persona}
              designServiceListData={list}
              currencyCode={currencyCode}
              locale={locale}
              width={width}
              replaceAddToCart={replaceAddToCart}
              disableRatings={disableRatings}
              replaceAddToCartCtaLink={replaceAddToCartCtaLink}
              replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
              linkNewTab={linkNewTab}
              disableEcommerce={disableEcommerce}
            />
          </div>
        )
      )
    })
  )
}

export default AddOnService
